import { genericGet } from "../../services/api.service";
import { EntityConfig } from "../..";


export const RecibosTableConfigs : EntityConfig = [
    {
      id: 'id',
      label: 'Id',
      type: 'id',
      nonEditable: true
    },
    {
      id: 'code',
      label: 'Número',
      type: 'text',
      filterable: true
    },
    {
      id: 'value',
      label: 'Valor',
      type: 'number',
      displayInfo: 'currency'

  },
    {
        id: 'client',
        label: 'Cliente',
        type: 'select',
        routable: true,
        filterable: true,
        options: {
          name: 'Cliente',
          route: 'clients',
          value: 'id',
          label: 'name',
          getter: ()=>genericGet('/findByFilter/clientes'),
          searcheable: true
        }
      },
    {
      id: 'bills',
      label: 'Faturas',
      type: 'multi-select',
      routable: true,
      options: {
        name: 'Fatura',
        route: 'faturacao-clientes',
        value: 'id',
        label: 'code',
        triggeredGetter: (i : number)=>genericGet(`/faturacao-clientes/unpaid/${i}`), // function to trigger according to other form parameter
        triggerParam: 'client', // Form parameter used to build getterfunction
        searcheable: true
      }
    },
    {
      id: 'paymentDate',
      label: 'Data de Pagamento',
      type: 'date',
      filterable: true

    },
  ];
  